// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bht_ss","PhotoTitleEditForm__cancelBtn":"iy_b bht_sw bht_sv"};